<template lang="pug">
  .container-outlay-coupon-detail.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item(:to="couponURL") 现金券详情
          el-breadcrumb-item 券包详情
    c-box
      el-form(:model="$data", label-position="right", label-width="100px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="券包 ID") {{ market_package.package_id }}
            el-form-item(label="券包名称") {{ market_package.title }}
            el-form-item(label="状态") {{ market_package.status | status }}
          el-col(:span="12")
            el-form-item(label="创建时间") {{ market_package.create_time }}
            el-form-item(label="有效期") {{ market_package.end_time }}
            el-form-item(label="创建者") {{ market_package.app_name }}
        el-form-item(label="")
          el-button(@click="toExportExcel", type="primary") 导出发放详情
    c-box
      .point-outer-container
        .point-container
          .point-title 现金券面额
          .point-amount {{ package_stat.amount | toYuan }}
        .point-container
          .point-title 现金券总值
          .point-amount {{ total_amount | toYuan }}
        .point-container
          .point-title 现金券总量
          .point-amount {{ total_quantity }} 张
    c-box
      .outlay-chart-container
        v-chart(ref="chart", class="outlay-chart", :options="chartOptions", :autoresize="true")
</template>

<script>
export default {
  data () {
    return {
      market_package: {},
      package_stat:   {
        'amount':                       0,
        'distributed_expired_amount':   0,
        'distributed_expired_quantity': 0,
        'distributed_unused_amount':    0,
        'distributed_unused_quantity':  0,
        'distributed_used_amount':      0,
        'distributed_used_quantity':    0,
        'frozen_amount':                0,
        'frozen_quantity':              0,
        'outlay_account_id':            null,
        'stock_amount':                 0,
        'stock_quantity':               0,
      },

      chartOptions:   {},

      listLoading:  false,
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    package_id () {
      return this.$route.params.package_id;
    },

    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    },
    couponURL () {
      return `/outlay/${this.outlay_account_id}/coupon`;
    },

    total_amount () {
      return this.package_stat.distributed_expired_amount + this.package_stat.distributed_unused_amount +
        this.package_stat.distributed_used_amount + this.package_stat.frozen_amount + this.package_stat.stock_amount;
    },
    total_quantity () {
      return this.package_stat.distributed_expired_quantity + this.package_stat.distributed_unused_quantity +
        this.package_stat.distributed_used_quantity + this.package_stat.frozen_quantity + this.package_stat.stock_quantity;
    },
  },
  filters: {
    status (source) {
      switch (source) {
        case  1:  return '待审核';
        case  2:  return '审核失败';
        case  3:  return '已审核';
        case  4:  return '已删除';
        case  5:  return '已过期';
        case  6:  return '已返还';
        default:  return source;
      }
    },
  },
  methods: {
    toExportExcel () {
      const baseURL = '/mch_web/v1/mch_payment/export_coupon_package_detail';
      const url = `${baseURL}?outlay_account_id=${this.outlay_account_id}&package_id=${this.package_id}`;

      console.log(url);
      window.open(url);
    },

    setChartOptions () {
      this.$refs.chart.showLoading();
      this.chartOptions = getChartOptions();
      this.chartOptions.title.subtext = this.package_stat.title;
      this.chartOptions.series[0].data = [
        setDataItem(this.package_stat.stock_quantity, this.package_stat.stock_amount, '未发放'),
        setDataItem(this.package_stat.distributed_unused_quantity, this.package_stat.distributed_unused_amount, '已发放-未使用'),
        setDataItem(this.package_stat.distributed_used_quantity, this.package_stat.distributed_used_amount, '已发放-已使用'),
        setDataItem(this.package_stat.distributed_expired_quantity, this.package_stat.distributed_expired_amount, '已发放-已过期'),
        setDataItem(this.package_stat.distributed_invalid_quantity, this.package_stat.distributed_invalid_amount, '已发放-已作废'),
      ];

      this.$refs.chart.hideLoading();
    },

    getDetail () {
      this.listLoading = true;

      this.$store.dispatch('GET_OUTLAY_ACCOUNT_COUPON_LIST', {
        offset:   0,
        limit:    1,
        stat:     true,
        outlay_account_id:  this.outlay_account_id,
        package_id:         this.package_id,
      }).then((data) => {
        if (data.list.length > 0) {
          const d = data.list[0];
          this.market_package = d.market_package;
          this.package_stat = d.package_stat;
          this.setChartOptions();
        } else {
          this.$alert(`找不到券包信息`, {
            type:     'error'
          }).then(() => {
            this.$router.push(this.couponURL);
          });
        }
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getDetail();
  },
};

function getChartOptions () {
  return {
    title: {
      text:     '现金券发放与使用情况',
      subtext:  '',
      x:        'center',
    },
    legend: {
      data:   ['未发放', '已发放-未使用', '已发放-已使用', '已发放-已过期', '已发放-已作废'],
      orient: 'vertical',
      left:   'left',
      top:    'bottom',
    },
    tooltip: {
      trigger: 'item',
      // formatter: "{b} : {c} （{d}%）"
    },
    series: [
      {
        name:   '发放情况',
        type:   'pie',
        data:   [],
        center: ['50%', '50%'],
        radius: '60%',
      },
    ]
  };
}

function setDataItem (quantity, amount, name) {
  return {
    value:  quantity,
    name,
    tooltip:  {
      formatter:  `{b}<br /> 数量：{c}（{d}%）<br /> 总值：${parseFloat(amount / 100).toFixed(2)}元`,
    },
  };
}
</script>